import React, { MouseEvent, useCallback } from 'react';
import { AppCustomIcons } from '../../utils/custom-icons';
import './app-svg-icon.scss';

export interface AppSvgIconProps {
  id?: string;
  icon: AppCustomIcons;
  onClick?: (e: MouseEvent<SVGSVGElement> | React.KeyboardEvent<SVGSVGElement>, id?: string) => void;
  className?: string;
  tabIndex?: number;
}

export const AppSvgIcon = (props: AppSvgIconProps) => {
  const handleClick = useCallback(
    (e: MouseEvent<SVGSVGElement>) => {
      props.onClick?.(e, props.id);
    },
    [props]
  );

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<SVGSVGElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        props.onClick?.(e, props.id);
      }
    },
    [props]
  );

  return (
    <svg
      id={props.id}
      className={`app-svg-icon ${props.icon} ${props.onClick ? 'app-svg-icon-pointer' : ''} ${props.className ?? ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={props.tabIndex ?? (props.onClick ? 0 : -1)}
    />
  );
};
